<template>
    <main class="" id="app">
        <div class="bg-page"></div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-8">
                <div class="title-center">
                    <h1>
                        <span class="icons-check-circle"></span>
                        {{ __('messages.get_ready_travel' + (rapd ? "rapd" : collectType == 2 ? "collect" : isDeposit ? "deposit" : "")) }} {{
                            data.customerFirstName }}!
                    </h1>
                </div>
                <div class="card shadow-300">

                    <div class="card-info-collumns pt-4">
                        <div class="two-collumns order-last border-left">
                            <span class="font-16 font-600" v-if="!rapd && !isDeposit">{{ __('messages.thankSite',
                                [siteConfig.appName]) }}</span>
                            <span class="font-16 font-600" v-if="isDeposit">{{ __('messages.title_card_deposit') }}</span>
                            <span class="font-16 font-600" v-if="rapd">{{ __('messages.rapdonlyfalt') }}</span>
                            <!-- Deposito bancario -->
                            <p class="pt-4 font-16 font-main" v-if="isDeposit" v-html="__('messages.depositmsgmain')"></p>
                            <!-- RAPD -->
                            <p v-if="rapd" class="pt-4 font-16" v-html="__('messages.completepayrapd')"></p>

                            <!-- <h3 v-if="collectType === 2 && !rapd" class="m-0">
                                {{ __('messages.pay_at_accommodation') }}
                                <br><br>
                                <b class="text-success">
                                    <currency-display
                                        :amount="(data.hotelInformation.serviceAmountTotal * data.hotelInformation.roomsCount) + this.amauntFeees"
                                        :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                                </b>
                            </h3> -->
                            <!-- <div v-if="collectType === 2">
                                <p class="text-small"
                                    v-if="!(getExchange.currency == currencyHC && (amauntTotal + this.amauntFeeesOriginal) == ((data.hotelInformation.serviceAmountTotal * data.hotelInformation.roomsCount) + this.amauntFeees))">
                                    {{ getExchange.currency != currencyHC ? __('messages.messagge-fee',
                                        [getExchange.currency]) : __('messages.messagge-fee', [' ']) }}
                                    <strong><currency-display :amount="amauntTotal + this.amauntFeeesOriginal"
                                            :showCurrencyCode="true" :applyDecimals="true" :currencyCode="currencyHC"
                                            :applyConvertion="false" :applySymbol="true"></currency-display></strong>
                                    {{ __('messages.messagge-fee-2') }}
                                </p>
                            </div> -->
                            <p class="pt-4 font-16"
                                v-if="rapd || !isDeposit && collectType != 2 ">
                                {{ __('messages.email_confirmation' + (rapd ? "rapd" : "")) }}
                                {{ data.customerEmail }}
                            </p>
                            <!-- HOTEL COBRA -->
                            <p v-if="collectType == 2" class="pt-4 font-16">
                                {{ __('messages.hotelcollectmsg') }}
                            </p>
                            <!-- RAPD -->
                            <p v-if="rapd && data.hotelInformation.serviceAmountBalance <= 0">
                                {{ __('messages.send_payment_link') }} {{ data.customerEmail }}
                            </p>
                            <p v-if="rapd" class="pt-4 font-16">
                                {{ __('messages.preferenrapd') }} <a class="btn-link"
                                    :href="'tel:' + siteConfig.phonePrimary">{{ siteConfig.phoneFormat }}</a>
                            </p>
                            <p v-if="collectType == 2" class="pt-4 font-16">
                                {{ __('messages.email_confirmationcollet') }} {{ data.customerEmail }}
                            </p>
                            <!-- General -->
                            <h3 class="pt-4">{{ __('messages.no_locator') }} {{ data.bookingId }}</h3>
                            <p class="pt-2 pb-4 font-16">{{ __('messages.use_number_locator') }}</p>
                            <!-- Deposito bancario -->
                            <button type="submit" v-if="isDeposit" @click="printReservation()"
                                class="btn font-16 btn-primary button-deposit btn-lg btn-middle but" >{{ __('messages.btnItineraryDeposit') }}</button>
                            <button type="submit" class="btn font-16 btn-lg btn-middle but"
                                :class="{ 'btn-secondary': isDeposit, 'btn-primary': !isDeposit }"
                                @click="getItineraryUri('/'+ culture.cultureCode +__('url.url_go_itinerary_' + siteConfig.siteName))">
                                {{ __('messages.check_itinerary') }}
                            </button>

                        </div>
                        <div class="two-collumns margin-mobile">
                            <h2>{{ __('messages.your_reservation') }}</h2>
                            <div class="card-flex">
                                <div class="image">
                                    <img class="rounded noPrint" :src="hotel.image" alt="Hotel preview" width="100%"
                                        height="auto">
                                </div>
                                <div class="info-product">
                                    <h3 class="text-rem">{{ data.hotelInformation.serviceCarrierName }}</h3>
                                    <p class="text-subtle">{{ hotel.location.city }}, {{ hotel.location.state }}, {{
                                        hotel.location.country }}</p>
                                    <span class="m-0 font-icons" :class="getStarClass()"
                                        :alt="'hotel ' + hotel.stars + ' estrellas'"></span>
                                    <p>
                                        <strong>{{ data.hotelInformation.roomsCount }} {{
                                            data.hotelInformation.roomsCount > 1 ?
                                                __("messages.rooms") : __("messages.room") }}, {{
                                                nights }} {{ nights > 1 ? __("messages.nights") : __("messages.night")
                                            }}</strong>
                                    </p>
                                </div>
                            </div>
                            <!-- comentado nose de donde tomar esta info -->
                            <!-- <div class="info-gray">
                                <p><strong>{{ __('messages.triptraslate') }}</strong> Round trip transfer</p>
                                <p><strong>{{ __('messages.tripsecure') }}</strong> Travel Blue Cobertura Nacional</p>
                                <p><strong>{{ __('messages.tripcar') }}</strong> Nissan Versa 2020</p>
                                <p><strong>{{ __('messages.triptour') }}</strong> Xcaret, Xcaret Plus (only entry)</p>
                            </div> -->
                            <!-- CARD RAPD -->
                            <div class="content-border" v-if="rapd">
                                <h3 class="mb-1">{{ __('messages.amounttopay') }}
                                    <span class="ml-2 font-400">
                                        <currency-display
                                            :amount="(amounTotalService) + this.amauntFeees"
                                            :showCurrencyCode="true" :applyDecimals="true"></currency-display></span>
                                </h3>
                                <p class="font-16">{{ __('messages.amoutpaydate') }}
                                    <span class="font-strong">{{ data.hotelInformation.cancellationPolicies.dateCancellation |
                                        date(__('formaters.rapdstep3'))}}</span>
                                </p>
                                <p class="font-subtle font-12 font-400 pt-1">{{ __('messages.amoutpaytime') }}
                                </p>
                            </div>
                            <!-- CARD RAPD -->
                            <!-- CARD DEPOSITO -->
                            <div class="content-border" v-if="isDeposit">
                                <h3 class="mb-1">{{ __('messages.amounttopay') }}
                                </h3>
                                <span class="font-main font-16 font-400">
                                    <currency-display :amount="amounTotalService + this.amauntFeees" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                                    <span v-if="!(getExchange.currency == data.currency)">(<currency-display
                                        :amount="amounTotalService + this.amauntFeeesOriginal" :showCurrencyCode="true"
                                        :applyDecimals="true" :currencyCode="data.currency" :applyConvertion="false"
                                        :applySymbol="true"></currency-display>)
                                    </span>
                                </span>
                                <p v-if="!(getExchange.currency == data.currency)" class="font-subtle font-12 font-400 pt-1">{{ getExchange.currency != data.currency ? __('messages.collect_fees',[getExchange.currency]) : __('messages.collect_fees', [' ']) }} 
                                    {{ __('messages.collect_fees2', [data.currency]) }}</p>
                                <p class="font-16 pt-3">
                                    {{ __('messages.amoutpaydate') }}
                                
                                </p>
                                <p class="font-16 font-400">{{ data.dateLimitDeposit |date(__('formaters.deposit'))}} hrs
                                    <br>
                                        <span>{{ __('formaters.formathrs') }}</span>
                                </p>
                                <p class="font-subtle font-12 font-400 pt-1">{{ __('messages.amoutpaytime') }}</p>
                            </div>
                            <!-- CARD DEPOSITO -->
                            <!-- CARD HOTEL COLLECT -->
                            <div class="content-border" v-if="collectType == 2">
                                <h3 class="mb-1">{{ __('messages.amounttopaycollect') }}
                                </h3>
                                <span class="font-main font-16">
                                    <currency-display
                                        :amount="amounTotalService + this.amauntFeees"
                                        :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                                    <span
                                        v-if="!(getExchange.currency == currencyHC && (amauntTotal + this.amauntFeeesOriginal) == (amounTotalService + this.amauntFeees))">(<currency-display
                                            :amount="amauntTotal + this.amauntFeeesOriginal" :showCurrencyCode="true"
                                            :applyDecimals="true" :currencyCode="currencyHC" :applyConvertion="false"
                                            :applySymbol="true"></currency-display>)</span>
                                </span>
                                <p class="font-subtle font-12 font-400 pt-1">{{ getExchange.currency != currencyHC ? __('messages.collect_fees',[getExchange.currency]) : __('messages.collect_fees', [' ']) }} 
                                    {{ __('messages.collect_fees2', [currencyHC]) }}</p>
                            </div>
                            <!-- CARD HOTEL COLLECT -->
                        </div>
                    </div>
                </div>
                <div class="card my-5">
                    <div class="title-card pb-0">
                        <h2>{{ data.customerFirstName }}, {{ __('messages.need_anything_else') }}</h2>
                    </div>
                    <div class="card-info-collumns">
                        <div class="two-collumns line-bottom">
                            <h3 class="mt-0 font-16">
                                <span class="icons-plane icons-title"></span>
                                {{ __('messages.reserve_flight') }}
                            </h3>
                            <p class="font-16">{{ __('messages.buy_flights_best_price') }}</p>
                            <button class="btn btn-secondary btn-lg but mt-3 button-special" :class="{ 'border-0': isDeposit }"
                                @click="redirectTo(__('url.url_packages'))">
                                {{ __('messages.view_more') }}
                            </button>
                        </div>
                        <div class="two-collumns">
                            <h3 class="mt-0 font-16">
                                <span class="icons-flame1 icons-title"></span>
                                {{ __('messages.special_deals') }}
                            </h3>
                            <p class="font-16">{{ __('messages.find_best_deals_travel') }}</p>
                            <button class="btn btn-secondary btn-sm but mt-3 button-special" :class="{ 'border-0': isDeposit }"
                                @click="redirectTo(__('url.url_tours_' + siteConfig.siteName))">
                                {{ __('messages.view_more') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>

</template>
<script>
import CancellationModal from '../modals/CancellationModal'
import ImageVoucher from './ImageVoucher';
import { AlgoliaServices } from '../../services/AlgoliaService';
import { storeToRefs } from 'pinia';
import { useExchangeRateStore } from "../../stores/exchange";
const site = window.__pt.settings.site;
const culture = window.__pt.cultureData;
export default {
    props: ['data', 'hotel', 'rapd', 'infoHotelPayment', 'isDeposit'],
    setup() {
        const exchangeStore = useExchangeRateStore();
        const { getExchange } = storeToRefs(exchangeStore);

        return { getExchange };
    },
    data() {
        return {
            culture,
            type: {},
            modalCancellation: 0,
            cancellation: {},
            siteConfig: site,
            amauntTotal: 0,
            amauntFeees: 0,
            amauntFeeesOriginal: 0,
            currencyHC: '',
            currencySite: culture.currencySymbol.replace(/[\$\s]/g, ''),
            currencySymbol: culture.currency,
            appName: site.appName,
            collectType: 0,
            groupedRoomsArray: [],
            adults: 0,
            kids: 0,
            show: false,
            nights: 0,
            amounTotalService: 0
        };
    },
    async mounted() {
        this.getEventAlgolia();
        this.getTotalsAmounts();
        this.adults = 0;
        this.kids = 0;
        this.cancellation = this.data.roomList.find(item => item.cancellationPolicies.isCancellationFree);
        this.show = !!this.cancellation;

        const groupedRooms = this.data.roomList.reduce((acc, room) => {
            const key = `${room.serviceCarrierDescription}-${room.mealPlanCode}`;
            if (!acc[key]) {
                acc[key] = {
                    description: room.serviceCarrierDescription,
                    mealPlanCode: room.mealPlanCode,
                    count: 0,
                };
            }
            acc[key].count += 1;
            this.adults += room.adults;
            this.kids += room.kids;
            return acc;
        }, {});

        this.groupedRoomsArray = Object.values(groupedRooms);
        this.nights = this.getNights(this.data.hotelInformation.startDate, this.data.hotelInformation.endDate);
    },
    methods: {
        printReservation() {
            this.$root.$emit('trigger-print');
        },
        formatDate(dateString) {
            if (!dateString) return '';

            const date = new Date(dateString);
            const dayName = date.toLocaleDateString(__pt.settings.site.culture, { weekday: 'long' });
            const day = date.getDate();
            const month = date.toLocaleDateString(__pt.settings.site.culture, { month: 'short' }).replace('.', ''); // Elimina el punto
            const year = date.getFullYear();

            return `${dayName} ${day}, ${month} ${year}`;
        },
        getItineraryUri(uri) {
            window.open(uri + '?MasterLocatorId=' + this.data.bookingId + '&email=' + this.data.customerEmail, '_blank');
        },
        getStarClass() {
            if (this.hotel.stars % 1 == 0) {
                return [`icon-${this.hotel.stars}-star`];
            } else {
                return [`icon-${Math.floor(this.hotel.stars)}-half-star`];
            }
        },
        openaModalCancellation() {
            this.modalCancellation = +1;
            $("#modal-cancellation").modal("show");
        },
        getEventAlgolia() {
            AlgoliaServices.getEventAlgolia("Order", "purchase");
        },
        getTotalsAmounts() {
            this.amauntTotal = 0;
            if (this.infoHotelPayment && this.infoHotelPayment.travelItinerary && this.infoHotelPayment.travelItinerary.bookingServices) {
                this.infoHotelPayment.travelItinerary.bookingServices.forEach((service) => { // Cambio a función de flecha
                    this.collectType = service.collectType;
                    if (service.rate) {
                        this.amauntTotal += service.rate.collectAmount;
                        if (!this.collectCurrency && service.rate.collectCurrency) {
                            this.currencyHC = service.rate.collectCurrency;
                        }
                    }
                    this.amauntFeees += service.serviceFees.reduce((accum, item) => accum + item.clientAmount, 0);
                    this.amauntFeeesOriginal += service.serviceFees.reduce((accum, item) => accum + item.amount, 0);
                });
            }
            if(this.data.roomList){
                this.data.roomList.forEach((room) => {  
                    this.amounTotalService += room.serviceAmountTotal;
                });
            }
        },
        getNights(startDate, endDate) {
            const inicio = new Date(startDate);
            const fin = new Date(endDate);
            const diferenciaMilisegundos = fin - inicio;
            const noches = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
            return noches;
        },
        redirectTo(url) {
            window.open(url, '_blank');
        }
    },
    components: {
        ImageVoucher,
        CancellationModal
    }
}
</script>
